export default __webpack_public_path__ + "e5736f64215a9f388ebcdf292c608093.svg";